var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.877,
    height: 30.5,
    viewBox: "0 0 25.877 30.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3551",
    "data-name": "Group 3551",
    transform: "translate(22428.25 1760.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9057",
    "data-name": "Path 9057",
    d: "M-22415.062-1731.75l8.375-8.375,2.656-6.469-.406-4.906-3.562-5.062-7.062-2.25-5.812,1.406-5.031,5.906-.656,6,2.406,5,6.688,7.438Z",
    fill: "#dc3a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "location_2_",
    "data-name": "location (2)",
    transform: "translate(-22467.451 -1760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2161",
    "data-name": "Group 2161",
    transform: "translate(39.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2160",
    "data-name": "Group 2160",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8590",
    "data-name": "Path 8590",
    d: "M61.112,3.716a12.688,12.688,0,0,0-21.661,8.972c0,6.856,6.483,12.559,9.965,15.622.484.426.9.793,1.235,1.1a2.186,2.186,0,0,0,2.976,0c.333-.311.751-.679,1.235-1.1,3.483-3.064,9.965-8.766,9.965-15.622A12.606,12.606,0,0,0,61.112,3.716ZM53.7,26.992c-.495.435-.922.811-1.274,1.14a.424.424,0,0,1-.577,0c-.352-.329-.779-.7-1.274-1.14-3.274-2.88-9.369-8.241-9.369-14.3a10.931,10.931,0,0,1,21.862,0C63.071,18.75,56.976,24.111,53.7,26.992Z",
    transform: "translate(-39.451)",
    fill: "#dc3a1a",
    stroke: "#dc3a1a",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2163",
    "data-name": "Group 2163",
    transform: "translate(46.462 6.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2162",
    "data-name": "Group 2162",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8591",
    "data-name": "Path 8591",
    d: "M166.248,112.938a5.678,5.678,0,1,0,5.678,5.678A5.684,5.684,0,0,0,166.248,112.938Zm0,9.571a3.893,3.893,0,1,1,3.893-3.893A3.9,3.9,0,0,1,166.248,122.509Z",
    transform: "translate(-160.57 -112.938)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOrange);
export default __webpack_public_path__ + "static/media/location_orange.ff8ef24f365cadc54713a1039868b859.svg";
export { ForwardRef as ReactComponent };